import { mergeQuoteRequirements } from "./mergeQuoteRequirements";

export function buildQuoteSummaryPayload({ eventType, quoteFormData, answers = {} }) {
  const conversationAnswers = Object.entries(answers)
    .filter(([key]) => !key.includes(" — ") && !key.endsWith(" ISO"))
    .map(([label, value]) => ({
      label,
      value: String(value),
    }));

  const mergedFormData = {
    ...(quoteFormData || {}),
  };

  if (answers["Event dates"]) {
    mergedFormData.date = answers["Event dates"];
  }

  if (answers["Event span"]) {
    mergedFormData.eventSpan = answers["Event span"];
  }

  if (answers["Add-ons"]) {
    mergedFormData.addons = answers["Add-ons"];
  }

  if (answers.Ceremonies) {
    mergedFormData.ceremonies = answers.Ceremonies;
  }

  mergedFormData.coverage = mergeQuoteRequirements({
    coverage: quoteFormData?.coverage,
    ceremonies: answers.Ceremonies,
    addons: answers["Add-ons"],
  });

  if (answers.Notes && answers.Notes !== "Skipped") {
    mergedFormData.notes = answers.Notes;
  }

  return {
    title: "Shared with our team",
    eventType: eventType || "",
    formData: mergedFormData,
    conversationAnswers,
  };
}

export default buildQuoteSummaryPayload;
